import config from "../config";
import { dataClickGTM, dataIdGTM } from "../utils/TrackingService";
import { CAR_HIRE_EXCESS_UK, CAR_HIRE_EXCESS_IE, CAR_HIRE_EXCESS_BLUE_IE } from "./companies";
import { configChe } from "./config_che";
import { configCheBlue } from "./config_che_blue";
import { getCurrentOrganisation } from "./getCurrentOrganisation";
import { link } from "./link";

const quoteLink155 =
    process.env.MIX_CHE_155_QUOTE_URL ||
    "https://carhireexcess-co-uk.ppr.halolynx.com";
const quoteLink156 =
    process.env.MIX_CHE_156_QUOTE_URL ||
    "https://carhireexcess-ie.ppr.halolynx.com/";
const quoteLink158 =
    process.env.MIX_CHE_158_QUOTE_URL ||
    "https://carhireexcess.blueinsurance.ie/";
const FAQLink155 =
    process.env.MIX_CHE_155_FAQ_URL ||
    "https://carhireexcess-co-uk.ppr.halolynx.com/faq";
const FAQLink156 =
    process.env.MIX_CHE_156_FAQ_URL ||
    "https://carhireexcess-ie.ppr.halolynx.com/faq";
    const FAQLink158 =
    process.env.MIX_CHE_158_FAQ_URL ||
    "https://www.blueinsurance.ie/faq_carhireexcess.asp";
const contactLink155 =
    process.env.MIX_CHE_155_CONTACT_URL ||
    "https://carhireexcess-co-uk.ppr.halolynx.com/contact";
const contactLink156 =
    process.env.MIX_CHE_156_CONTACT_URL ||
    "https://carhireexcess-ie.ppr.halolynx.com/contact";
    const contactLink158 =
    process.env.MIX_CHE_158_CONTACT_URL ||
    "https://www.blueinsurance.ie/contact-us.asp";

const CMS_BLUE = process.env.MIX_CHE_158_URL || 'https://www.blueinsurance.ie/'

export const configs = {
    [CAR_HIRE_EXCESS_UK]: {
        ...configChe,
        header: {
            logo: "che-logo.svg",
            externalLinks: [
                link("Get a quote", `${quoteLink155}`, "url", "", {
                    dataId: dataIdGTM.get_quote_btn,
                    dataClickText: dataClickGTM.get_quote_btn,
                }),
                link("Claims", "/claims", "", "", {
                    dataId: dataIdGTM.claims_btn,
                    dataClickText: dataClickGTM.claims_btn,
                }),
                link("FAQ", `${FAQLink155}`, "url", "", {
                    dataId: dataIdGTM.faq_btn,
                    dataClickText: dataClickGTM.faq_btn,
                }),
                link("Contact us", `${contactLink155}`, "url", "", {
                    dataId: dataIdGTM.contact_us_btn,
                    dataClickText: dataClickGTM.contact_us_btn,
                }),
            ],
            links: [
                link("Your Policy", "/dashboard", "", "",{
                    dataId: dataIdGTM.your_policy,
                    dataClickText: dataClickGTM.your_policy,
                }),
                link("Documents", "/documents", "", "",{
                    dataId: dataIdGTM.documents,
                    dataClickText: dataClickGTM.documents,
                }),
                link("Claims", "/claims", "", "",{
                    dataId: dataIdGTM.claims_btn,
                    dataClickText: dataClickGTM.claims_btn,
                }),
            ],
            helpButton: {
                links: [
                    link(
                        "0333 355 6182",
                        "tel:0333 355 6182",
                        "url",
                        "phone.svg"
                    ),
                    link(
                        "info@carhireexcess.com",
                        "mailto:info@carhireexcess.com",
                        "url",
                        "mail.svg"
                    ),
                ],
                info: [
                    { heading: "Mon - Fri", text: "9:00am to 5:00pm" },
                    { heading: "Sat", text: "Closed" },
                    { heading: "Sunday", text: "Closed" },
                ],
            },
            avatar: {
                userInfo: {
                    name: "Olivia Rhye",
                    email: "design@covermore.com",
                }, //todo: remove after login complete,
                links: [
                    link(
                        "Billing Details",
                        "/billing-details",
                        "",
                        "credit-card.svg",
                        {
                            dataId: dataIdGTM.billing_details,
                            dataClickText: dataClickGTM.billing_details,
                        }

                    ),
                    link("FAQ", `${FAQLink155}`, "url", "help-icon.svg", {
                        dataId: dataIdGTM.faq_btn,
                        dataClickText: dataClickGTM.faq_btn,
                    }),
                    link(
                        "Contact",
                        "https://carhireexcess-co-uk.ppr.halolynx.com/contact",
                        "url",
                        "mail.svg", {
                            dataId: dataIdGTM.contact_us_btn,
                        dataClickText: dataClickGTM.contact_us_btn,
                    }
                    ),
                ],
            },
        },
        footer: {
            links: [
                link(
                    "Privacy policy",
                    "https://www.blueinsurance.ie/PrivacyPolicy/UK/",
                    "url",
                    ""
                ),
                link(
                    "Cookie policy",
                    `${quoteLink155}/cookie-policy`,
                    "url",
                    ""
                ),
                link(
                    "Contact",
                    contactLink155,
                    "url",
                    ""
                ),
            ],
            description:
                "Cover-More Blue Insurance Services Limited trading as Carhireexcess.com is a private limited company incorporated in Ireland with company number 345681 and with its UK branch office registered at 82 Oxford Road, Uxbridge, Middlesex, UB8 1UX. It is authorised and regulated in the United Kingdom by the Financial Conduct Authority, Firm Reference No. 984290.UK Office: Parkview, 82 Oxford Road, Uxbridge, UB8 1UX",
            copyRight:
                "© 2023 Cover-More Insurance Service Ltd. All rights reserved.",
        },
        claimsPage: {
            title: "Newline Group Claims",
            description: "Welcome to the Online Claims Notification Portal for policyholders underwritten by Newline Group",
            content_title: "Insurer details",
            content_image: "newline-logo.svg",
            content_description:"Newline Insurance Company Limited” is a private limited company incorporated in England and Wales. Registration No. 04409827. Registered Office: 1 Fen Court, London England EC3M 5BN. Newline Insurance Company Limited is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority. Newline Insurance Company Limited’s company number is 04409827 and its FCA Firm Reference Number is 435028."
         },
        googleTagId: process.env.MIX_GTM_ID_155 || "GTM-MXXM7M42",
        sessionExpiredLinks: [
            link("Get a quote", `${quoteLink155}`, "url", ""),
            link("Retrieve a quote", `${quoteLink155}`, "url", ""),
            link("Ask us a question", `${quoteLink155}`, "url", ""),
            link("Customer login", `${quoteLink155}`, "url", ""),
            link("About our car hire insurance", `${quoteLink155}`, "url", ""),
        ],
        theme_css: "che_uk",
        agency_code: 155,
        thankyou_text:"Thank you for choosing Car Hire Excess Insurance",
        start_date_max_days:179,
        gtm_data:{
            item_brand:"Carhire excess IE",
            affiliation:"Carhireexcess Renewals",
            item_category:"Elective Renewal Policy"
        },
        auto_renew_enable_days:42,
        auto_renew_disable_days:28,
        auto_renew_enable_progress_bar_bol:true,
        auto_renew_disable_progress_bar_bol:false,
        region: 'GB',
        quote_link:quoteLink155,
        phone_number:"0333 355 6182",
        disable_mta_button_days:null,
        documents:{
            toba:config.TOBA_GB,
            pw:config.PW_GB,
            ipid:config.IPID_GB
          },
        stripe_key:config.STRIPE_KEY_GB,
        policy_login_url:"https://www.carhireexcess.com/Policy/PolicyAccount/PolicyLogin?AgencyId=1149"

    },
    declaration_content: {
        phone_number: "0333 355 6182",
        email: "info@carhireexcess.co.uk",
    },
    [CAR_HIRE_EXCESS_IE]: {
        ...configChe,
        header: {
            logo: "che-logo.svg",
            externalLinks: [
                link("Get a quote", `${quoteLink156}`, "url", "", {
                    dataId: dataIdGTM.get_quote_btn,
                    dataClickText: dataClickGTM.get_quote_btn,
                }),
                link("Claims", "/claims", "", "", {
                    dataId: dataIdGTM.claims_btn,
                    dataClickText: dataClickGTM.claims_btn,
                }),
                link("FAQ", `${FAQLink156}`, "url", "", {
                    dataId: dataIdGTM.faq_btn,
                    dataClickText: dataClickGTM.faq_btn,
                }),
                link("Contact us", `${contactLink156}`, "url", "", {
                    dataId: dataIdGTM.contact_us_btn,
                    dataClickText: dataClickGTM.contact_us_btn,
                }),
            ],
            links: [
                link("Your Policy", "/dashboard", "", "",{
                    dataId: dataIdGTM.your_policy,
                    dataClickText: dataClickGTM.your_policy,
                }),
                link("Documents", "/documents", "", "",{
                    dataId: dataIdGTM.documents,
                    dataClickText: dataClickGTM.documents,
                }),
                link("Claims", "/claims", "", "",{
                    dataId: dataIdGTM.claims_btn,
                    dataClickText: dataClickGTM.claims_btn,
                }),
            ],
            helpButton: {
                links: [
                    link(
                        "0818 44 44 47",
                        "tel:0818 44 44 47",
                        "url",
                        "phone.svg"
                    ),
                    link(
                        "info@carhireexcess.com",
                        "mailto:info@carhireexcess.com",
                        "url",
                        "mail.svg"
                    ),
                ],
                info: [
                    { heading: "Mon - Fri", text: "9:00am to 5:00pm" },
                    { heading: "Sat", text: "Closed" },
                    { heading: "Sunday", text: "Closed" },
                ],
            },
            avatar: {
                userInfo: {
                    name: "Olivia Rhye",
                    email: "design@covermore.com",
                }, //todo: remove after login complete,
                links: [
                    link(
                        "Billing Details",
                        "/billing-details",
                        "",
                        "credit-card.svg",
                        {
                            dataId: dataIdGTM.billing_details,
                            dataClickText: dataClickGTM.billing_details,
                        }
                    ),
                    link("FAQ", `${FAQLink156}`, "url", "help-icon.svg", {
                        dataId: dataIdGTM.faq_btn,
                        dataClickText: dataClickGTM.faq_btn,
                    }),
                    link("Contact", `${contactLink156}`, "url", "mail.svg", {
                        dataId: dataIdGTM.contact_us_btn,
                        dataClickText: dataClickGTM.contact_us_btn,
                    }),
                ],
            },
        },
        footer: {
            links: [
                link(
                    "Privacy policy",
                    "https://www.blueinsurance.ie/PrivacyPolicy/IE/",
                    "url",
                    ""
                ),
                link(
                    "Cookie policy",
                    `${quoteLink156}/cookie-policy`,
                    "url",
                    ""
                ),
                link("Contact", `${contactLink156}`, "url", ""),
                link(
                    "Accessibility",
                    `${quoteLink156}/accessibility`,
                    "url",
                    ""
                ),
            ],
            description:"Cover-More Blue Insurance Services Limited trading as carhireexcess.ie  is regulated by the Central Bank of Ireland.",
            copyRight:
                "© 2025 Cover-More Blue Insurance Services Limited. All rights reserved.",
        },

        claimsPage: {
            title: "Lloyd’s Insurance Company Claims",
            description: "Welcome to the Online Claims Notification Portal for policyholders underwritten by Lloyd’s Insurance Company",
            content_title: "Insurer details",
            content_image: "lloyed-logo.svg",
            content_description: "Lloyd’s Insurance Company S.A. is a Belgian limited liability company (société anonyme / naamloze vennootschap) with its registered office at Bastion Tower, Marsveldplein 5, 1050 Brussels, Belgium and registered with Banque Carrefour des Entreprises / Kruispuntbank van Ondernemingen under number 682.594.839 RLE (Brussels). It is an insurance company subject to the supervision of the National Bank of Belgium. Its Firm Reference Number(s) and other details can be found on https://www.nbb.be/",
        },
        googleTagId: process.env.MIX_GTM_ID_156 || "GTM-MXXM7M42",
        sessionExpiredLinks: [
            link("Get a quote", `${quoteLink155}`, "url", ""),
            link("Retrieve a quote", `${quoteLink155}`, "url", ""),
            link("Ask us a question", `${quoteLink155}`, "url", ""),
            link("Customer login", `${quoteLink155}`, "url", ""),
            link("About our car hire insurance", `${quoteLink155}`, "url", ""),
        ],
        theme_css: "che_uk",
        agency_code: 156,
        thankyou_text:"Thank you for choosing Car Hire Excess Insurance",
        start_date_max_days:179,
        gtm_data:{
            item_brand:"Carhire excess IE",
            affiliation:"Carhireexcess Renewals",
            item_category:"Elective Renewal Policy"
        },
        auto_renew_enable_days:42,
        auto_renew_disable_days:28,
        auto_renew_enable_progress_bar_bol:true,
        auto_renew_disable_progress_bar_bol:false,
        region: 'IE',
        quote_link:quoteLink156,
        phone_number:"0818 44 44 47",
        disable_mta_button_days:null,
        documents:{
            toba:  config.TOBA_IE,
            pw:config.PW_IE,
            ipid:config.IPID_IE
          },
        stripe_key:config.STRIPE_KEY_IE,
        policy_login_url:"https://www.carhireexcess.com/Policy/PolicyAccount/PolicyLogin?AgencyId=1148",
        declaration_content: {
            phone_number: "01-4854113",
            email: "info@carhireexcess.ie",
        },
    },
    [CAR_HIRE_EXCESS_BLUE_IE]: {
        ...configCheBlue,
        header: {
            logo: "che-logo_blue.svg",
            externalLinks: [
                link("Get a quote", `${quoteLink158}`, "url", "", {
                    dataId: dataIdGTM.get_quote_btn,
                    dataClickText: dataClickGTM.get_quote_btn,
                }),
                link("Claims", "/claims", "", "", {
                    dataId: dataIdGTM.claims_btn,
                    dataClickText: dataClickGTM.claims_btn,
                }),
                link("FAQ", `${FAQLink158}`, "url", "", {
                    dataId: dataIdGTM.faq_btn,
                    dataClickText: dataClickGTM.faq_btn,
                }),
                link("Contact us", `${contactLink158}`, "url", "", {
                    dataId: dataIdGTM.contact_us_btn,
                    dataClickText: dataClickGTM.contact_us_btn,
                }),
            ],
            links: [
                link("Your Policy", "/dashboard", "", "",{
                    dataId: dataIdGTM.your_policy,
                    dataClickText: dataClickGTM.your_policy,
                }),
                link("Documents", "/documents", "", "",{
                    dataId: dataIdGTM.documents,
                    dataClickText: dataClickGTM.documents,
                }),
                link("Claims", "/claims", "", "",{
                    dataId: dataIdGTM.claims_btn,
                    dataClickText: dataClickGTM.claims_btn,
                }),
            ],
            helpButton: {
                links: [
                    link(
                        "0818 44 44 47",
                        "tel:0818 44 44 47",
                        "url",
                        "phone_blue.svg"
                    ),
                    link(
                        "info@carhireexcess.com",
                        "mailto:info@carhireexcess.com",
                        "url",
                        "mail_blue.svg"
                    ),
                ],
                info: [
                    { heading: "Mon - Fri", text: "9:00am to 5:00pm" },
                    { heading: "Sat", text: "Closed" },
                    { heading: "Sunday", text: "Closed" },
                ],
            },
            avatar: {
                userInfo: {
                    name: "Olivia Rhye",
                    email: "design@covermore.com",
                }, //todo: remove after login complete,
                links: [
                    link(
                        "Billing Details",
                        "/billing-details",
                        "",
                        "credit-card_blue.svg",
                        {
                            dataId: dataIdGTM.billing_details,
                            dataClickText: dataClickGTM.billing_details,
                        }
                    ),
                    link("FAQ", `${FAQLink158}`, "url", "help-icon_blue.svg", {
                        dataId: dataIdGTM.faq_btn,
                        dataClickText: dataClickGTM.faq_btn,
                    }),
                    link("Contact", `${contactLink158}`, "url", "mail_blue.svg", {
                        dataId: dataIdGTM.contact_us_btn,
                        dataClickText: dataClickGTM.contact_us_btn,
                    }),
                ],
            },
        },
        footer: {
            links: [
                link(
                    "Privacy policy",
                    "https://www.blueinsurance.ie/PrivacyPolicy/IE/",
                    "url",
                    ""
                ),
                link(
                    "Cookie policy",
                    `${quoteLink156}/cookie-policy`,
                    "url",
                    ""
                ),
                link("Contact", `${contactLink158}`, "url", ""),
                link("Accessibility", `${CMS_BLUE}/blue-accessibility-statement.asp`, "url", ""),
            ],
            description:
                "Cover-More Blue Insurance Services Limited trading as Blueinsurance.ie is regulated by the Central Bank of Ireland.",
            copyRight:
                "© 2025 Cover-More Blue Insurance Services Limited. All rights reserved.",
        },

        claimsPage:{
            title:"Lloyd’s Insurance Company Claims",
            description:"Welcome to the Online Claims Notification Portal for policyholders underwritten by Lloyd’s Insurance Company",
            content_title:"Insurer details",
            content_image:"lloyed-logo.svg",
            content_description:"Lloyd’s Insurance Company S.A. is a Belgian limited liability company (société anonyme / naamloze vennootschap) with its registered office at Bastion Tower, Marsveldplein 5, 1050 Brussels, Belgium and registered with Banque Carrefour des Entreprises / Kruispuntbank van Ondernemingen under number 682.594.839 RLE (Brussels). It is an insurance company subject to the supervision of the National Bank of Belgium. Its Firm Reference Number(s) and other details can be found on https://www.nbb.be/",
        },
        googleTagId: process.env.MIX_GTM_ID_158 || "GTM-5Z4WDK3J",
        sessionExpiredLinks: [
            link("Get a quote", `${quoteLink158}`, "url", ""),
            link("Retrieve a quote", `${quoteLink158}`, "url", ""),
            link("Ask us a question", `${quoteLink158}`, "url", ""),
            link("Customer login", `${quoteLink158}`, "url", ""),
            link("About our car hire insurance", `${quoteLink158}`, "url", ""),
        ],
        theme_css: "che_blue",
        agency_code: 158,
        primary_color:"#1565B8",
        thankyou_text:"Thank you for choosing Blueinsurance.ie Car Hire Excess",
        start_date_max_days:364,
        gtm_data:{
            item_brand:"Blueinsurance.ie - Carhireexcess - Renewals",
            affiliation:"Covermore Renewals",
            item_category:"Renewals website"
        },
        auto_renew_enable_days:42,
        auto_renew_disable_days:42,
        auto_renew_enable_progress_bar_bol:true,
        auto_renew_disable_progress_bar_bol:true,
        region: 'IE',
        quote_link:quoteLink158,
        phone_number:"0818 44 44 47",
        disable_mta_button_days:14,
        documents:{
          toba:  config.TOBA_BLUE,
          pw:config.PW_BLUE,
          ipid:config.IPID_IE
        },
        stripe_key:config.STRIPE_KEY_BLUE,
        declaration_content: {
            phone_number: " 01-5135976",
            email: " info@blueinsurance.ie",
        },
        policy_login_url:"https://www.blueinsurance.ie/VC/index.asp?Product=che",
        agent_config: {
            backdate_message: "You are now backdating this policy , please make sure you have supervisor /underwriter approval.",
        }

    },
};

export const getOrganisationConfig = (organisation) => {
    return configs[organisation];
};

export const getCurrentOrganisationConfig = () => {
    return getOrganisationConfig(getCurrentOrganisation());
};
